<div class="header">
  <div class="title">Edit Tags</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="tagForm">
  <mat-form-field class="example-chip-list">
    <mat-chip-list #chipList aria-label="Tag selection" class="my-2">
      <mat-chip
        *ngFor="let tag of tags | keyvalue"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="removeTag(tag.value)"
      >
        {{ tag.value }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
      <input
        class="my-2"
        placeholder="New tag..."
        #tagInput
        [formControlName]="'tag_list'"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addTag($event)"
        (focus)="tagInput.focused = true"
        (blur)="tagInput.focused = false"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTag($event)">
      <mat-option *ngFor="let tag of foundTags | keyvalue" [value]="tag.key">
        {{ tag.key }}
      </mat-option>
    </mat-autocomplete>
    <mat-hint *ngIf="tagInput.focused" class="mt-2">
      Press <strong>TAB</strong> key after finishing typing to add a new tag
    </mat-hint>
  </mat-form-field>

  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button tabindex="1" type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        tabindex="0"
        [disabled]="tagForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!tagForm.disabled">Save</span>
        <mat-progress-spinner *ngIf="tagForm.disabled" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
